export default __webpack_public_path__ + "static/media/cleaning-1.fb8c3b5f.jpg";